import { TaskError, ErrorType } from '@nexelem/graphne-api';

/** Has other error than overdue error */
export const hasCriticalError = (errors: TaskError[] = []): boolean =>
  errors.map(({ errorType }) => errorType).some((errorType) => errorType !== ErrorType.Overdue);
